import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const lineChannel = defineChannel({
  id: 'line',
  icon: 'brand/line',
  name: 'LINE message',
  shortName: 'LINE',
  noun: 'LINE message',
  events: ['attempted', 'sent', 'delivered', 'failed', 'clicked', 'converted'],
  deliveryStates: ['attempted', 'sent', 'failed', 'holdout', 'delivered'],
  deliveryActions: ['clicked', 'converted'],
} as const satisfies ChannelDefinition);
